import { ROTransaction } from '../../../db'
import { RemoteAuthSession, RemoteAuthSessionRepository } from '../domain/remoteAppAuthService'

const reviver = (key: string, value: string) => {
  if (key === 'validTo') {
    return new Date(value)
  }
  return value
}

export class LocalStorageRemoteAuthSessionRepository implements RemoteAuthSessionRepository {
  constructor(private key: string) {}

  async get(): Promise<RemoteAuthSession | undefined> {
    const session = localStorage.getItem(this.key)
    return session ? JSON.parse(session, reviver) : undefined
  }

  async set(tx: ROTransaction, session: RemoteAuthSession | undefined): Promise<void> {
    if (localStorage.getItem(this.key)) localStorage.removeItem(this.key)
    if (session) localStorage.setItem(this.key, JSON.stringify(session))
  }
}
